import { activeStageLegendItem } from '../components/sequencer-legend-items';

interface CompressorHighlightState {
  activeStageLegendLabel: string;
  highlightedStage: number | undefined;
}

export const getCompressorHighlightState = ({
  activeStage,
  cosmicActive,
  cosmicFallbackStage,
}: {
  activeStage: unknown;
  cosmicActive: boolean | undefined;
  cosmicFallbackStage: number | undefined;
}): CompressorHighlightState => {
  const useCosmicFallbackHighlight = cosmicActive === true && cosmicFallbackStage !== undefined;

  return {
    activeStageLegendLabel: useCosmicFallbackHighlight
      ? 'Cosmic Fallback Stage'
      : activeStageLegendItem.label,
    highlightedStage:
      cosmicActive === true
        ? useCosmicFallbackHighlight
          ? cosmicFallbackStage
          : undefined
        : typeof activeStage === 'number'
          ? activeStage
          : undefined,
  };
};
